import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { formatarPlaca, placaValida } from '../services/inspecaoService';
import { excluirInspecao, listarInspecoesPendentes } from '../services/inspecaoDb';

export default function PlacaVeiculo({ onContinuar, setAviso }) {
  const [placa, setPlaca] = useState('');
  const [erro, setErro] = useState('');
  const [pendentes, setPendentes] = useState([]);

  const carregarPendentes = () => {
    listarInspecoesPendentes()
      .then((lista) => setPendentes(lista.filter((item) => item.quantidadeFotos > 0)))
      .catch(() => setPendentes([]));
  };

  useEffect(carregarPendentes, []);

  const continuar = (e) => {
    if (e) e.preventDefault();
    if (!placaValida(placa)) {
      setErro('Informe a placa no formato ABC-1D23 ou ABC-1234.');
      return;
    }
    setErro('');
    onContinuar(placa);
  };

  const confirmarDescarte = (inspecao) => setAviso({
    titulo: 'Descartar inspeção',
    mensagem: `Deseja excluir a inspeção da placa ${inspecao.placa} e as ${inspecao.quantidadeFotos} foto(s) ainda não enviadas?`,
    textoConfirmar: 'Excluir',
    destrutivo: true,
    onConfirmar: async () => {
      await excluirInspecao(inspecao.id);
      carregarPendentes();
    },
  });

  return (
    <div className="oficina-pagina">
      <form className="oficina-card" onSubmit={continuar} noValidate>
        <h2 className="oficina-titulo">Inspeção veicular</h2>
        <p className="oficina-subtitulo">Informe a placa do veículo para iniciar.</p>
        <input
          className={`oficina-input-placa ${erro ? 'is-erro' : ''}`}
          autoCapitalize="characters"
          autoCorrect="off"
          autoComplete="off"
          spellCheck={false}
          maxLength={8}
          placeholder="ABC-1D23"
          aria-label="Placa do veículo"
          value={placa}
          onChange={(e) => { setPlaca(formatarPlaca(e.target.value)); setErro(''); }}
        />
        {erro ? <p className="oficina-erro">{erro}</p> : null}
        <button type="submit" className="oficina-botao oficina-botao-primario oficina-botao-bloco">Continuar</button>
      </form>

      {pendentes.length ? (
        <section className="oficina-card oficina-pendentes">
          <h3>Inspeções não enviadas</h3>
          <p className="oficina-subtitulo">Fotos guardadas neste aparelho aguardando envio.</p>
          <ul>
            {pendentes.map((inspecao) => (
              <li key={inspecao.id}>
                <button type="button" className="oficina-pendente-abrir" onClick={() => onContinuar(inspecao.placa)}>
                  <strong>{inspecao.placa}</strong>
                  <span>{inspecao.quantidadeFotos} foto(s) · {moment(inspecao.criadoEm).format('DD/MM/YYYY HH:mm')}</span>
                </button>
                <button type="button" className="oficina-icone-botao" aria-label={`Descartar inspeção ${inspecao.placa}`} onClick={() => confirmarDescarte(inspecao)}>
                  <i className="pi pi-trash" />
                </button>
              </li>
            ))}
          </ul>
        </section>
      ) : null}
    </div>
  );
}
